import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import { MetricCard } from '../MetricCard';
import { formatMetricNumber } from './formatNumber';

export function MetricsKpiCards({ metrics, scope, locale }) {
  const { t } = useTranslation();

  const fourthCard =
    scope === 'organization'
      ? {
          icon: <PeopleIcon fontSize="small" />,
          label: t('metrics.members'),
          value: formatMetricNumber(metrics.members?.total, locale),
          subtitle: t('metrics.membersInOrganization'),
          color: '#ffa726',
        }
      : {
          icon: <BusinessIcon fontSize="small" />,
          label: t('metrics.organizations'),
          value: formatMetricNumber(metrics.organizations?.total, locale),
          subtitle: t('metrics.usersTotal', {
            count: formatMetricNumber(metrics.users?.total, locale),
          }),
          color: '#ffa726',
        };

  const cards = [
    {
      icon: <FolderIcon fontSize="small" />,
      label: t('metrics.projectsTotal'),
      value: formatMetricNumber(metrics.projects?.total, locale),
      subtitle: t('metrics.projectsThisMonth', {
        count: formatMetricNumber(metrics.projects?.createdThisMonth, locale),
      }),
      color: 'primary.main',
    },
    {
      icon: <AutoAwesomeIcon fontSize="small" />,
      label: t('metrics.aiRenders'),
      value: formatMetricNumber(metrics.aiRenders?.totalExecuted, locale),
      subtitle: t('metrics.thisMonth', {
        count: formatMetricNumber(metrics.aiRenders?.thisMonth, locale),
      }),
      color: '#ab47bc',
    },
    {
      icon: <ContentCutIcon fontSize="small" />,
      label: t('metrics.optimizations'),
      value: formatMetricNumber(metrics.optimizations?.totalExecuted, locale),
      subtitle: t('metrics.thisMonth', {
        count: formatMetricNumber(metrics.optimizations?.thisMonth, locale),
      }),
      color: '#66bb6a',
    },
    fourthCard,
  ];

  return (
    <Grid container spacing={{ xs: 2, sm: 2.5 }}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} lg={3} key={card.label}>
          <MetricCard {...card} />
        </Grid>
      ))}
    </Grid>
  );
}
